var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 17.25C11.9013 17.2501 11.8037 17.2308 11.7127 17.1931C11.6217 17.1554 11.539 17.1001 11.4694 17.0304L3.96943 9.53036C3.82878 9.38971 3.74976 9.19894 3.74976 9.00002C3.74976 8.8011 3.82878 8.61033 3.96943 8.46968C4.11009 8.32902 4.30086 8.25 4.49978 8.25C4.69869 8.25 4.88946 8.32902 5.03012 8.46968L11.9998 15.4393L18.9694 8.46968C19.1101 8.32902 19.3009 8.25 19.4998 8.25C19.6987 8.25 19.8895 8.32902 20.0301 8.46968C20.1708 8.61033 20.2498 8.8011 20.2498 9.00002C20.2498 9.19894 20.1708 9.38971 20.0301 9.53036L12.5301 17.0304C12.4605 17.1001 12.3779 17.1554 12.2869 17.1931C12.1959 17.2308 12.0983 17.2501 11.9998 17.25Z",
    fill: "#939190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.ce12a0d0fd85af195cec7591c0b6c131.svg";
export { ForwardRef as ReactComponent };